export default __webpack_public_path__ + "static/media/icon-feather-check.352480e2.svg";